<template>
  <div id="payment-form--financials">
    <!-- Card type -->
    <CardType
      @change="cardTypeChange"
      v-if="additionalChargeEnabled && !technologyFeeEnabled"
      :credit-card-surcharge="additionalCharge"
      :card-type="cardType"/>

    <v-layout row wrap>
      <v-flex xs12>
        <h2>Currently Due</h2>
        <hr />
      </v-flex>
    </v-layout>

    <!-- invoices !-->
    <v-layout
      v-for="(invoice, index) in invoices"
      :key="`invoice_${invoice.id}`"
      row
      wrap>
      <v-flex xs12>
        <Invoice :hg-invoice="invoice" :surcharge="surcharge" />
      </v-flex>
      <v-container v-if="index < invoices.length - 1" py-0>
        <v-flex xs12 md4 offset-md8>
          <hr />
        </v-flex>
      </v-container>
    </v-layout>

    <!-- amount due !-->
    <v-container py-0>
      <v-layout row wrap>
        <v-flex xs8 offset-xs4>
          <hr />
        </v-flex>

        <v-flex xs12 text-xs-right>
          <p class="payment-amount amount-due">
            Amount Due <span v-if="isPayrix">(USD):</span>
            <span class="payment-amount-number">{{ currency(paymentTotal) }}</span>
          </p>
        </v-flex>
      </v-layout>
    </v-container>
    <CardMismatchModal
      :show="showCardMismatchModal"
      @close="showCardMismatchModal = false"
      :payment-amount="paymentAmount"
      :credit-card-surcharge="additionalCharge"
      :invoices="invoices"
      :card-type="cardType"
      @changeCardType="cardTypeChange"/>
  </div>
</template>

<script>
import { Mixins } from '@homegauge/vue';
import { mapState } from 'vuex';
import featureFlags from '../../constants/feature-flags';
import Invoice from './Invoice.vue';
import CardType from './CardType.vue';
import CardMismatchModal from './CardMismatchModal.vue';

const { CurrencyFilter } = Mixins;

export default {
  data() {
    return {
      cardType: '',
      showCardMismatchModal: false,
    };
  },
  components: {
    Invoice,
    CardType,
    CardMismatchModal,
  },
  props: {
    apiError: {
      type: Object,
      default: () => null,
    },
    invoices: {
      type: Array,
      default: () => [],
    },
    paymentAmount: {
      type: Number,
      default: 0,
    },
    isPayrix: {
      type: Boolean,
      default: false,
    },
    additionalCharge: {
      type: Number,
      default: 0,
    },
    additionalChargeEnabled: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapState('unleash', {
      enabledFeatures: state => state.enabledFeatures,
    }),
    technologyFeeEnabled() {
      return this.enabledFeatures[featureFlags.TECHNOLOGY_FEE];
    },
    surcharge() {
      return (
        {
          value: this.additionalCharge / 100,
          enabled: this.additionalChargeEnabled,
          label: this.enabledFeatures[featureFlags.TECHNOLOGY_FEE]
            ? 'Technology Fee'
            : 'Credit Card Surcharge',
        } || {}
      );
    },
    paymentTotal() {
      return this.surcharge.enabled
        ? (this.paymentAmount * this.additionalCharge) / 10000 + this.paymentAmount
        : this.paymentAmount;
    },
  },
  mixins: [CurrencyFilter],
  methods: {
    cardTypeChange(data) {
      this.cardType = data;
      this.$emit('cardTypeChange', this.cardType);
    },
  },
  watch: {
    apiError() {
      if (this.apiError?.fieldViolations.find(field => field.field === 'paymentTokenCardType')) {
        this.showCardMismatchModal = true;
        this.$scrollTo('#payment-form--alerts');
      } else if (this.apiError) {
        this.$scrollTo('#payment-form--alerts');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/typography';

.payment-amount {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1.786rem;
  font-weight: $typography-weight-bold;
}

.payment-amount-number {
  font-weight: $typography-weight-normal;
  font-size: 1.786rem;
  color: rgba(0, 0, 0, 0.6);
}

hr {
  background-color: rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 0, 0, 0.15);
  border-width: 0;
  height: 1px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}

.amount-due {
  float: right;
}
</style>
